import axios from 'axios';
import { API } from '../../shared/config';

const PREFIXE_CP = { LU: 'L-', FR: 'F-', BE: 'B-', DE: 'D-' };
const PAYS_FR = { LU: 'Luxembourg', FR: 'France', BE: 'Belgique', DE: 'Allemagne' };

export const ddnFr = (d) => {
  const s = String(d || '');
  const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  return iso ? `${iso[3]}/${iso[2]}/${iso[1]}` : s;
};

const age = (ddn) => {
  const m = ddnFr(ddn).match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (!m) return '';
  const n = new Date(), b = new Date(+m[3], +m[2] - 1, +m[1]);
  let mois = (n.getFullYear() - b.getFullYear()) * 12 + n.getMonth() - b.getMonth() - (n.getDate() < b.getDate() ? 1 : 0);
  if (mois < 0) return '';
  if (mois < 24) return `${mois} mois`;
  const ans = Math.floor(mois / 12);
  return `${ans} ans${mois % 12 >= 6 ? ' et demi' : ''}`;
};

const tel = (t) => {
  const m = String(t || '').trim().match(/^(\+\d{1,3})\s*(\d+)$/);
  if (!m) return String(t || '').trim();
  const g = (s, k) => s.match(new RegExp(`.{1,${k}}`, 'g')).join(' ');
  return m[1] === '+352' ? g(m[2], 3) : `${m[1]} ${m[2].length % 2 ? m[2][0] + ' ' + g(m[2].slice(1), 2) : g(m[2], 2)}`;
};

const villeDuCp = async (pays, cp) => {
  if (!PREFIXE_CP[pays] || !cp) return '';
  try { return (await axios.get(`${API}/adresse/rues`, { params: { pays, cp } })).data.localites?.[0] || ''; } catch { return ''; }
};

/** Fiche patient au format secrétariat (civilité, naissance + âge, matricule, adresse, téléphone, e-mail). */
export const texteFichePatient = async (pt = {}) => {
  const civ = { F: 'Madame', M: 'Monsieur' }[pt.civ];
  const lignes = [[civ, pt.prenom, pt.nom].filter(Boolean).join(' ')];
  if (pt.ddn) lignes.push(`Date de naissance : ${ddnFr(pt.ddn)}${age(pt.ddn) ? ` ; ${age(pt.ddn)}` : ''}`);
  const c = String(pt.cns || '').replace(/\D/g, '');
  if (c) lignes.push(`N° de matricule : ${c.length === 13 ? `${c.slice(0, 4)} ${c.slice(4, 6)} ${c.slice(6, 8)} ${c.slice(8, 11)} ${c.slice(11)}` : c}${pt.caisse ? `  / ${pt.caisse}` : ''}`);
  if (pt.addr_rue || pt.addr_cp || pt.addr) {
    const ville = pt.addr_ville || await villeDuCp(pt.pays, pt.addr_cp);
    const rue = [pt.addr_num, pt.addr_rue].filter(Boolean).join(', ');
    const cp = pt.addr_cp ? `${PREFIXE_CP[pt.pays] || ''}${String(pt.addr_cp).replace(/^[A-Z]-/i, '')}` : '';
    const pays = pt.pays && !PREFIXE_CP[pt.pays] ? pt.pays : (pt.pays && pt.pays !== 'LU' && !ville ? PAYS_FR[pt.pays] : '');
    lignes.push(`Adresse : ${[rue || pt.addr, cp, ville, pays].filter(Boolean).join(' ')}`);
  }
  if (pt.tel) lignes.push(`Téléphone : ${tel(pt.tel)}`);
  if (pt.email) lignes.push(`Email : ${pt.email}`);
  return lignes.join('\n');
};

export const copierTexte = async (texte) => {
  try { await navigator.clipboard.writeText(texte); return true; } catch {
    const ta = document.createElement('textarea');
    ta.value = texte; ta.style.position = 'fixed'; ta.style.opacity = '0';
    document.body.appendChild(ta); ta.select();
    const ok = document.execCommand('copy');
    ta.remove();
    return ok;
  }
};
